// ═════════════════════════════════════════════════════════════════════════════
// NHCX Coverage Eligibility API client
//
// Contract: COVERAGE_ELIGIBILITY_UI_INTEGRATION.md (repo root).
//
//   POST /app/api/insurance/coverage-eligibility/check/   → 200 { correlation_id, poll_url, … }
//   GET  /app/api/insurance/response/{correlation_id}/     → 404 while waiting, 200 once the payer answers
//
// This is an ASYNCHRONOUS API. A 200 on /check means "submitted to NHCX", not
// "here is the eligibility answer" — the caller polls for the answer separately.
// A 404 from /response is the normal waiting state, never an error.
// ═════════════════════════════════════════════════════════════════════════════

import axios from "axios";
import {
  NHCX_BASE_URL,
  nhcxUrl,
  nhcxHeaders,
  pollNhcxResponse,
  normalizeNhcxError,
} from "./nhcx-client";

// Re-exported so existing imports of COVERAGE_BASE_URL keep working.
export const COVERAGE_BASE_URL = NHCX_BASE_URL;

/** POST the check. Resolves with the submission envelope (correlation_id inside). */
export async function submitEligibilityCheck(body) {
  const res = await axios.post(nhcxUrl("/coverage-eligibility/check/"), body, {
    headers: nhcxHeaders(),
  });
  return res.data;
}

export const pollEligibilityResponse = pollNhcxResponse;

export function normalizeCheckError(err) {
  return normalizeNhcxError(err, {
    404: "Admission not found on the eligibility service.",
    500: "The eligibility service failed to build the request. Quote the API call id to support.",
    503: "The eligibility service database is unavailable. Try again in a moment.",
  });
}
